<template>
  <section class="form-config sr-add">
    <!-- <el-row type="flex" :gutter="20"> -->
    <el-form
      :ref="refForm"
      :rules="rules"
      :model="form"
      @submit.native.prevent
      size="medium"
      :hide-required-asterisk="formComConfig.textModel || false"
      :label-position="
        formComConfig.labelPosition ? formComConfig.labelPosition : 'top'
      "
      :label-suffix="formComConfig.labelSuffix ? formComConfig.labelSuffix : ''"
      :disabled="isDisabledAll"
      :label-width="
        formComConfig.labelNum ? formComConfig.labelNum + 'px' : '190px'
      "
      :validate-on-rule-change="formComConfig.validateOnRuleChange || false"
    >
      <template v-for="(item, index) in config">
        <!-- 子标题 -->
        <div v-if="item.type == 'subTitle'" :key="'fa-item-' + index" class="fa-sub-title">
          <SrSubTitle :title="item.name"></SrSubTitle>
        </div>
        <template v-else>
          <el-form-item
            :key="'fa-item-' + index"
            v-if="!item.isHide"
            :label="item.name"
            :prop="item.bind"
            :class="[
              'col-' + (item.col ? item.col : 12),
              { textarea_vertical: item.type == 'auto_textarea' },
              'relative',
              'border-box',
              item.className,
              { rightSlot: item.rightSlot },
              { closePadding: item.closePadding },
              { 'text-model': getTextModel(item) },
            ]"
            :style="'display:' + item.display"
          >
            <!-- 自定义label -->
            <template v-if="item.tipContent" slot="label">
              {{ item.name }}
              <el-tooltip class="item" effect="dark" :content="item.tipContent" placement="top">
                <i class="icon-prompt"></i>
              </el-tooltip>
            </template>
            <template v-if="item.type === 'upload' && item.fileTip" slot="label">
              {{ item.name }}
              <el-tooltip class="item" effect="dark" :content="item.fileTip" placement="top">
                <i class="icon-prompt"></i>
              </el-tooltip>
            </template>
            <!--    按钮开关 -->
            <FormItemSwitch
              v-else-if="item.type === 'switch'"
              :item="item"
              :form="form"
              :formComConfig="formComConfig"
            />
            <!--    单选   -->
            <FormItemRadio
              v-else-if="item.type === 'radio'"
              :item="item"
              :form="form"
              :formComConfig="formComConfig"
              :enums="enums"
            />
            <!--    复选框   -->
            <FormItemCheckbox
              v-else-if="item.type === 'checkbox'"
              :item="item"
              :form="form"
              :formComConfig="formComConfig"
              :enums="enums"
            />
            <!-- 空盒子 -->
            <slot v-else-if="item.type === 'slot'" :name="item.slotName"></slot>
            <!--   input   -->
            <FormItemInput
              v-else-if="item.type === 'input'"
              :item="item"
              :form="form"
              :formComConfig="formComConfig"
              :callFn="callFn"
            />
            <!-- tooltip 显示输入内容 -->
            <div v-else-if="item.type == 'text'">
              <SrText v-model.trim="form[item.bind]" :item="item" :formComConfig="formComConfig"></SrText>
            </div>
            <!--   input 数字选择框-->
            <FormItemInputNumber
              v-else-if="item.type == 'number'"
              :item="item"
              :form="form"
              :formComConfig="formComConfig"
            />
            <!--   select 下拉框   -->
            <FormItemSelect
              v-else-if="item.type === 'select'"
              :item="item"
              :form="form"
              :formComConfig="formComConfig"
              :enums="enums"
            />
            <!--   dialogselect   -->
            <div v-else-if="item.type == 'dialogSelect'">
              <sr-dialog-select
                v-bind="item"
                :item="item"
                :formComConfig="formComConfig"
                @select="
                  (val) => {
                    item.select && item.select(val, item);
                  }
                "
              ></sr-dialog-select>
            </div>
            <!--   textarea  -->
            <div v-else-if="item.type == 'textarea'">
              <SrTextarea
                v-model="form[item.bind]"
                @change="
                  item.change ? item.change(val, item) : callFn(item, $event)
                "
                :item="item"
                :formComConfig="formComConfig"
              ></SrTextarea>
            </div>

            <!--   富文本   -->
            <div v-else-if="item.type == 'editor'">
              <template v-if="!getTextModel(item)">
                <sr-kind-editor
                  :id="'KindEditor' + item.bind"
                  :readonlyMode="item.readonly"
                  :pluginsPath="pluginsPath"
                  :placeholder="item.placeholder"
                  :item="item"
                  ref="KindEditor"
                  v-bind="item"
                  :content.sync="form[item.bind]"
                />
              </template>
              <div v-else v-html="form[item.bind]"></div>
            </div>

            <!--   dete    -->
            <FormItemDateSelect
              v-else-if="item.type == 'dateSelect'"
              :item="item"
              :form="form"
              :formComConfig="formComConfig"
            />

            <!--   关联时间选择器 -->
            <div v-else-if="item.type == 'dateRelevancy'">
              <SrDatePicker
                v-model="form[item.bind]"
                :startname="item.startname ? item.startname : false"
                :endname="item.endname ? item.endname : false"
                :item="item"
                :formComConfig="formComConfig"
                @change="
                  (val) => {
                    item.change && item.change(form[item.bind], item);
                  }
                "
              ></SrDatePicker>
            </div>
            <!-- 图片上传 -->
            <SrUpload
              v-else-if="item.type === 'uploadImg'"
              :noAuthentication="item.noAuthentication"
              v-model="form[item.bind]"
              :item="item"
              :form="form"
              :formComConfig="formComConfig"
            ></SrUpload>

            <!--动态选择器 -->
            <FormItemCascader
              v-else-if="item.type == 'cascader'"
              :item="item"
              :form="form"
              :formComConfig="formComConfig"
              :enums="enums"
            />
            <!-- 选专家 -->
            <sr-select-people
              v-model="form[item.bind]"
              v-bind="item"
              @addPeople="
                () => {
                  item.addPeople && item.addPeople();
                }
              "
              @delPeople="
                () => {
                  item.delPeople && item.delPeople();
                }
              "
              v-else-if="item.type === 'selectPeople'"
              :view="getTextModel(item)"
            ></sr-select-people>

            <sr-duration
              v-model="form[item.bind]"
              v-else-if="item.type === 'duration'"
              :item="item"
              :formComConfig="formComConfig"
            ></sr-duration>

            <sr-tag
              v-model="form[item.bind]"
              v-bind="item"
              v-else-if="item.type === 'tag'"
              :item="item"
              :formComConfig="formComConfig"
            ></sr-tag>

            <!--   评分-->
            <div v-else-if="item.type == 'star'" class="flexBox ver-middle">
              <el-popover placement="bottom" trigger="hover" v-if="item.hover">
                <div>
                  <div class="title">{{ item.hover }}</div>
                </div>
                <el-rate
                  slot="reference"
                  v-model="form[item.bind]"
                  v-bind="item"
                  :disabled="getTextModel(item)"
                ></el-rate>
              </el-popover>
              <el-rate
                v-else-if="item.scoreTemplateType"
                slot="reference"
                v-model="form[item.bind]"
                v-bind="item"
                @change="validatorField(item)"
                :score-template="`${form[item.bind] * 2}`"
                :disabled="getTextModel(item)"
              ></el-rate>
              <el-rate
                v-else
                slot="reference"
                v-model="form[item.bind]"
                @change="validatorField(item)"
                :score-template="form[item.bind] + '分'"
                :disabled="getTextModel(item)"
                v-bind="item"
              ></el-rate>
            </div>
            <!--   upload 上传-->
            <div v-if="item.type == 'upload'">
              <template v-if="!getTextModel(item)">
                <SrBigUpload
                  v-on="$listeners"
                  ref="srUpload"
                  @uploadSuccess="
                    (data) => {
                      BigFileUploadSuccess(data, item);
                    }
                  "
                  @resume="
                    (data) => {
                      clearValidateItem(item);
                    }
                  "
                  @startUpload="
                    (data) => {
                      clearValidateItem(item);
                    }
                  "
                  @download="
                    (data) => {
                      this.download && this.download(data);
                    }
                  "
                  :fileList="
                    form[item.bind] &&
                    Array.isArray(form[item.bind]) &&
                    form[item.bind].length
                      ? form[item.bind]
                      : item.fileList
                  "
                  :item="item"
                >
                  <template v-for="(index, name) in $scopedSlots" v-slot:[name]>
                    <slot v-if="item.templateDownload" :name="name" v-bind="item"></slot>
                  </template>
                </SrBigUpload>
              </template>
              <UploaderView
                :data-up="item"
                :view-data="
                  form[item.bind] &&
                  Array.isArray(form[item.bind]) &&
                  form[item.bind].length
                    ? form[item.bind]
                    : item.fileList
                "
                :emptyPlacehoder="item.emptyPlacehoder"
                v-else
              ></UploaderView>
            </div>
          </el-form-item>
        </template>
      </template>
      <el-form-item v-if="button && button.length" style="width: 100%; text-align: center">
        <el-button
          v-for="(btn, index) in button"
          :key="index"
          :type="btn.type ? btn.type : ''"
          @click="callFn(btn)"
        >{{ btn.name }}</el-button>
      </el-form-item>
    </el-form>
    <!-- </el-row> -->
  </section>
</template>
<script>
import FormItemSwitch from './components/form-item-switch.vue';
import FormItemRadio from './components/form-item-radio.vue';
import FormItemCheckbox from './components/form-item-checkbox.vue';
import FormItemInput from './components/form-item-input.vue';
import FormItemInputNumber from './components/form-item-input-number.vue';
import FormItemSelect from './components/form-item-select.vue';
import FormItemDateSelect from './components/form-item-date-select.vue';
import FormItemCascader from './components/form-item-cascader.vue';
import UploaderView from '../SrView/uploaderView.vue';
import { getRules } from './rules.js';
const ruleItem = getRules();
export default {
  name: 'SrAdd',
  components: {
    FormItemSwitch,
    FormItemRadio,
    FormItemCheckbox,
    FormItemInput,
    FormItemInputNumber,
    FormItemSelect,
    FormItemDateSelect,
    FormItemCascader,
    UploaderView
  },
  inject: ['baseUrl', 'imgBaseUrl', 'uploadBaseUrl', 'previewUrl'],
  props: {
    formComConfig: {
      type: [Object],
      default() {
        return {
          labelNum: 190,
          labelSuffix: '',
          labelPosition: 'top',
          textModel: false
        };
      }
    },
    config: {
      type: Array
    },
    button: {
      type: Array
    },
    form: {
      type: [Object, Array]
    },
    refForm: {
      type: String,
      default: 'refForm'
    },
    enums: {
      type: Object
    },
    column: {
      type: Number
    },
    otherRule: {
      type: Object
    },
    isDisabledAll: Boolean // 禁用表单
  },
  computed: {
    pluginsPath: function () {
      return window.location.origin + '/front-res/plugins/kindeditor/plugins/';
    },
    origin() {
      return sessionStorage.getItem('origin') || '';
    }
  },
  data() {
    return {
      temporary: {}, // 不参与业务的组件内部临时变量
      fileList: [],
      rules: {},
      file: null
    };
  },
  watch: {
    config: {
      handler(val) {
        if (val.length > 0) {
          this.createRulesRequired();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.createRulesRequired();
    this.initTemporary();
  },
  methods: {
    getTextModel(item) {
      if (undefined === item.isText || '' === item.isText) {
        // item没有设置是否纯文本显示，判断全局的textModel
        return this.formComConfig.textModel;
      } else {
        return item.isText;
      }
    },
    // 清除单字段校验
    clearValidateItem(item) {
      this.$refs[this.refForm].clearValidate([item.bind]);
    },
    /**
     * 单字段校验
     */
    validatorField(item) {
      this.$refs[this.refForm].validateField(item.bind);
    },
    /**
     * 初始化临时变量
     */
    initTemporary() {
      let obj = {};
      this.config.map((res) => {
        if (res.temporary) {
          obj[res.temporary || res.bind] = '';
        }
      });
      this.temporary = obj;
    },
    /**
     * 校验表单，通过返回表单，否则返回false
     */
    validate(callback) {
      let flag = false;
      let rs = null;
      this.$refs.srUpload &&
        this.$refs.srUpload.map((res) => {
          if (res.uploader.isUploading()) {
            this.$message.warning('附件上传中!');
            flag = true;
            return false;
          }
        });
      if (!flag) {
        this.$refs[this.refForm].validate((valid) => {
          if (callback) {
            callback(valid);
          } else {
            if (valid) {
              let newPar = JSON.stringify(this.form).replace(
                new RegExp('\\\\"', 'gm'),
                "'"
              );
              rs = JSON.parse(newPar);
            }
          }
        });
        return rs;
      }
    },
    /**
     * 创建表单校验规则
     */
    createRulesRequired() {
      let obj = {};
      this.config.map((res) => {
        // 必填项校验
        if (res.bind) {
          let arr = res.required
            ? [Object.assign({}, ruleItem.requiredText[0])]
            : [];
          if (res.required) {
            if (res.trigger) {
              arr[0].trigger = res.trigger;
            }
            if (arr[0].required) {
              arr[0].message = res.required;
            }
          }
          obj[res.bind] = arr;
        }
        if (res.type === 'textarea' && res.maxlength) {
          if (res.rules) {
            res.rules[
              `maxLength_${res.maxlength}`
            ] = `请输入${res.maxlength}个字符以内的内容`;
          } else {
            res.rules = {
              [`maxLength_${res.maxlength}`]: `请输入${res.maxlength}个字符以内的内容`
            };
          }
        }
      });
      this.otherRules(obj);
    },
    /**
     * 其他校验
     * @param {Object} obj 基础校验完成的对象
     */
    otherRules(obj) {
      this.config.map((res) => {
        if (res.rules) {
          // 有额外校验
          for (let key in res.rules) {
            if (key.indexOf('maxLength') != -1) {
              // 长度类型
              let validator = Object.assign({}, ruleItem['maxLength'][0]);
              let arr = [validator];
              arr[0].message = res.rules[key];
              arr[0].trigger = res.trigger || arr[0].trigger;
              arr[0].max = key.split('maxLength_')[1] - 0;
              obj[res.bind] = [...obj[res.bind], ...arr];
            } else if (key.indexOf('regular') != -1) {
              // 正则匹配
              let validator = Object.assign({}, ruleItem['regular'][0]);
              let arr = [validator];
              arr[0].message = res.rules[key];
              arr[0].trigger = res.trigger || arr[0].trigger;
              arr[0].pattern = ruleItem.regularList[key.split('regular_')[1]];
              obj[res.bind] = [...obj[res.bind], ...arr];
            } else if (key.indexOf('validator') != -1) {
              // 自定义事件
              let validator = Object.assign({}, ruleItem['validator'][0]);
              let arr = [validator];
              arr[0].trigger = res.trigger || arr[0].trigger;
              arr[0].validator = (rule, value, callback) => {
                res.rules[key](rule, value, callback, res);
              };
              obj[res.bind] = [...obj[res.bind], ...arr];
            } else if (key.indexOf('define') != -1) {
              // 正则匹配
              let validator = Object.assign({}, ruleItem['define'][0]);
              let arr = [validator];
              arr[0].message = res.rules[key].message;
              arr[0].trigger = res.rules[key].trigger || arr[0].trigger;
              if (typeof res.rules[key].pattern == 'string') {
                arr[0].pattern = eval(res.rules[key].pattern);
              } else {
                arr[0].pattern = res.rules[key].pattern;
              }

              obj[res.bind] = [...obj[res.bind], ...arr];
            } else {
              // 其他rule.js里有的校验类型
              let item = Object.assign({}, ruleItem[key][0]);
              let arr = [];
              arr.push(item);
              arr[0].message = res.rules[key];
              arr[0].trigger = res.trigger || arr[0].trigger;
              obj[res.bind] = [...obj[res.bind], ...arr];
            }
          }
        }
      });

      this.rules = obj;
    },
    /**
     * 自定义校验事件
     */
    validator(rule, value, callback) {
      if (value - 500 > 0) {
        callback(new Error('这个值太大了'));
      } else {
        callback();
      }
    },
    /**
     * 时间选择限制
     */
    disabledDate() {
      return false;
    },
    resetForm() {
      //重置
      this.$refs[this.refForm].resetFields();
    },

    // 分片上传成功
    BigFileUploadSuccess(fileList, item) {
      this.$set(this.form, item.bind, fileList);
      this.$set(item, 'fileList', fileList);
    },

    callFn(btn, $event) {
      //操作事件
      if (btn.method && btn.method.constructor == Function) {
        // 兼容以前，扩展传入fn方式
        btn.method(btn, this.form);
        return;
      }
      let sum = 0;
      let obj = this.getDeepMethod(this.$parent, btn.method, sum, 10);
      if (obj.parent && obj.method) {
        obj.method.call(obj.parent, $event, this.form, this.config);
      }
    },
    // 递归找method
    getDeepMethod(parent, method, sum, limit) {
      sum++;
      if (!parent) {
        return {};
      } else if (sum == limit) {
        return {};
      } else if (parent[method]) {
        return {
          parent,
          method: parent[method]
        };
      } else {
        return this.getDeepMethod(parent.$parent, method);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// packages/SrAdd/SrAdd.vue